import '../../monitoring/filters/tag/tags_filter_view.js.coffee'

Namespace 'Profiling.Dashboard.Filters'

class Profiling.Dashboard.Filters.TagsFilterView extends Monitoring.Views.SocialContents.Filters.TagsFilterView
  className: 'tag-filter profiling-tag-filter'

  initialize: ({searchQuery, title, tagsByClientCode, facets}) ->
    super(
      searchQuery: searchQuery
      tagsByClientCode: tagsByClientCode
      facet: tag: terms: facets.tag.terms
    )
    @title = title

  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()

  _addCustomValues: ->

  getTitle: =>
    @title
